import type { ComponentType, PropsWithChildren } from "react";
import { RouterProvider, type createBrowserRouter } from './lib';

export const withRouter = (
    Component: ComponentType<PropsWithChildren>,
    factory: () => ReturnType<typeof createBrowserRouter>
) => {
    const router = factory();

    return () => (
        <Component>
            <RouterProvider
                router={router}
            />
        </Component>
    );
};

export default withRouter;
